<template>
    <div>
      <div class="" style="text-align: center;" v-if="isok">
          <p style="color:red; font-size:20px; margin:80px;">验证完成</p>
          <p style="font-size:20px">邮箱验证完成，快去完成注册吧！</p>
      </div>
      <div class="" style="text-align: center;" v-else>
          <p style="color:red; font-size:20px; margin:80px;">验证失败</p>
          <p style="font-size:20px">邮箱验证失败，请重新验证邮箱！</p>
      </div>
    </div>
</template>
<script>
export default {
  data () {
    return {
      isok: true
    }
  },
  mounted () {
    var param = this.$route.params.t

    if (param.length === 0) {
      this.$Message.info('验证码为空')
      return
    }
    var url = this.$store.state.baseurl + '/mapi/entry/verify'
    console.log('url', url)
    var that = this
    this.axios.get(
      url,
      {
        params: {
          t: param
        }
      }
    ).then(function (res) {
      if (res.data.code === 200) {
        that.isok = true
      } else {
        that.isok = false
        that.$Message.info(res.data.msg)
      }
    }).catch((e) => {
      that.isok = false
      that.$Message.info('邮箱验证失败')
    })
  },
  methods: {
  }
}
</script>
<style lang="less" scoped>

</style>



// WEBPACK FOOTER //
// src/components/verifyok.vue